import { ReactElement, useState } from 'react';
import { DetailsPanel, EditIcon, FormatInformation, IconButton } from '@weareopenr/component-library';
import { IOpeningTime, ITimes, IVenue } from 'src/types/venue.types';
import styles from './VenueOpeningTimesContents.module.scss';
import { capitalise } from 'src/helpers/capitalise';
import { WEEKDAYS, WEEKENDS } from 'src/constants';
import VenueOpeningTimeEditModal from '../VenueOpeningTimeEditModal';

export interface IVenueOpeningTimesContents {
  venue: IVenue;
}

const VenueOpeningTimesContents = ({ venue }: IVenueOpeningTimesContents) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleModalClick = () => setIsModalOpen((prev: boolean) => !prev);

  return (
    <>
      <DetailsPanel
        title="Opening times"
        action={
          <IconButton buttonStyle="ghost" onClick={handleModalClick} icon={EditIcon} aria-label="Edit opening times" />
        }
      >
        <DetailsPanel.Row>
          <DetailsPanel.Column>
            {WEEKDAYS.map((day) => {
              const checkedDay = venue.openingTimes.find((item: IOpeningTime) => item.dayOfWeek === day);
              return (
                <FormatInformation
                  key={`${venue.venueId}-${capitalise(day)}`}
                  data-cy={`${day}-info`}
                  heading={capitalise(day)}
                >
                  {checkedDay?.times.length > 0
                    ? checkedDay?.times.map(
                        (time: ITimes, i: number): ReactElement => (
                          <span
                            className={styles['times']}
                            key={`${venue.venueId}-${i}`}
                          >{`${time.startTime} - ${time.endTime}`}</span>
                        ),
                      )
                    : '-'}
                </FormatInformation>
              );
            })}
          </DetailsPanel.Column>
          <DetailsPanel.Column>
            {WEEKENDS.map((day) => {
              const checkedDay = venue.openingTimes.find((item: IOpeningTime) => item.dayOfWeek === day);
              return (
                <FormatInformation
                  key={`${venue.venueId}-${capitalise(day)}`}
                  data-cy={`${day}-info`}
                  heading={capitalise(day)}
                >
                  {checkedDay?.times.length > 0
                    ? checkedDay?.times.map(
                        (time: ITimes, i: number): ReactElement => (
                          <span
                            className={styles['times']}
                            key={`${venue.venueId}-${i}`}
                          >{`${time.startTime} - ${time.endTime}`}</span>
                        ),
                      )
                    : '-'}
                </FormatInformation>
              );
            })}
          </DetailsPanel.Column>
        </DetailsPanel.Row>
      </DetailsPanel>
      <VenueOpeningTimeEditModal isModalOpen={isModalOpen} onModalClose={handleModalClick} venue={venue} />
    </>
  );
};

export default VenueOpeningTimesContents;
